// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';

import CourseListIcon from '../../../../assets/images/course-list-icon.svg';
import LabListIcon from '../../../../assets/images/lab-list-icon.svg';
import SearchIcon from '../../../../assets/images/icon-search.svg';
import LinkIcon from '../../../../assets/images/recommendation-link.svg';
import ChallengListIcon from '../../../../assets/images/challenge-list-icon.svg';

import { CardTypes } from '../../../../types/Model';

const getIcon = (type: CardTypes) => {
  switch (type) {
    case CardTypes.COURSE:
      return CourseListIcon;
    case CardTypes.LAB:
      return LabListIcon;
    case CardTypes.CHALLENGE:
      return ChallengListIcon;
    default:
      return null;
  }
}

export const S = {
  Container: styled.div`
    display: flex;
    flex-grow: 1;
    height: 50px;

    padding-left: 20px;
    padding-right: 12px;
    margin-right: 183px;
    border-radius: 4px;
    align-items: center;
    justify-content: space-between;

    position: relative;
    background: #fff;
  `,
  Input: styled.input`
    flex-grow: 1;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
  `,
  Icon: styled.img.attrs({ src: SearchIcon, alt: 'search-icon' })`
    margin-left: 18px;
    cursor: pointer;
  `,
  RecommendationContainer: styled.div`
    position: absolute;
    top: 100%;
    left: 0px;

    width: 100%;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);

    border-radius: 4px;
    z-index: 2;
  `,
  RecommendationRow: styled.div`
    height: 50px;

    border-radius: 4px;
    padding-left: 14px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: rgba(201,201,201,0.3);
      cursor: pointer;
    }
  `,
  RecommendationIcon: styled.img.attrs<{ type: CardTypes }>(props => ({ src: getIcon(props.type), alt: 'recommendation-icon', draggable: false })) <{ type: CardTypes }>`
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  `,
  RecommendationTitle: styled.div`
    font: 16px Noto Sans TC;
    color: #434343;
    display: flex;
    align-items: center;
  `,
  RecommendationLinkIcon: styled.img.attrs({ src: LinkIcon, alt: 'recommendation-link' })`
    cursor: pointer;
    width: 20px;
    height: 20px;
  `,
};
